import { type FC } from 'react'
import { IntegrationIcon } from '../../../components/IntegrationIcon'
import { getSupportedProviderFromAdhocMeetingLink, PROVIDER_CONFIG } from '../../../common/meetingProviders'
import { MeetingMode } from '../../../models/Scheduling'

interface ProviderBadgeProps {
  meetingMode?: MeetingMode
  meetingUrl?: string
}

export const ProviderBadge: FC<ProviderBadgeProps> = ({ meetingMode, meetingUrl }) => {
  if (meetingMode === MeetingMode.IN_PERSON) {
    return <span className='paragraph-small zocks-bg-color-warning zocks-text-gray-900 rounded-3 px-2 py-1'>In person</span>
  }

  const provider = meetingUrl ? getSupportedProviderFromAdhocMeetingLink(meetingUrl) : undefined
  const config = provider ? PROVIDER_CONFIG[provider] : undefined
  if (config) {
    return (
      <span className='d-inline-flex align-items-center zocks-gap-0.25 paragraph-small zocks-bg-color-gray-100 zocks-text-gray-900 rounded-3 px-2 py-1'>
        <IntegrationIcon serviceId={config.serviceId} width={16} height={16} />
        {config.label}
      </span>
    )
  }

  return (
    <span className='d-inline-flex align-items-center zocks-gap-0.25 paragraph-small zocks-bg-color-cyan zocks-text-dark-green rounded-3 px-2 py-1'>
      <i className='bi bi-camera-video' />
      Video call
    </span>
  )
}
